import React, { useEffect, useState } from "react";
import Header from "./Header";
import BackgroundImg from "../img/BackgroundNetImg.svg";
import api from "../../api/axiosInstance";
import { useLocation, useNavigate } from "react-router-dom";
import CustomLoader from "../sellermodule/CustomLoader";

const ProductDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, project_type } = location.state || {};
  const [appDetails, setAppDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const features = [
    {
      name: "Feature 1",
      description: "Description for feature 1",
      logo: "https://via.placeholder.com/150",
    },
    {
      name: "Feature 2",
      description: "Description for feature 2",
      logo: "https://via.placeholder.com/150",
    },
    {
      name: "Feature 3",
      description: "Description for feature 3",
      logo: "https://via.placeholder.com/150",
    },
    {
      name: "Feature 4",
      description: "Description for feature 4",
      logo: "https://via.placeholder.com/150",
    },
  ];

  useEffect(() => {
    const fetchAppDetails = async () => {
      try {
        const response = await api.get(`/display/api/v1/display-project/${id}`);
        if (response.data?.status === "success") {
          console.log("API Response:", response.data.data);
          setAppDetails(response.data.data);
          setTimeout(() => {
            setLoading(false);
          }, 100);
        }
      } catch (error) {
        console.error("Error fetching app details:", error);
      }
    };

    if (id) {
      fetchAppDetails();
    }
  }, [id]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (loading || !appDetails) {
    return <CustomLoader></CustomLoader>;
  }

  return (
    <div>
      <Header />
      <div
        className="fixed bg-white bg-cover bg-center w-full"
        style={{
          backgroundImage: `url(${BackgroundImg})`,
          backgroundPosition: "50% 0%",
        }}
      >
        <div className="flex flex-col sm:p-14 p-5  overflow-y-auto max-h-[calc(100vh-64px)] scrollbar-hide">
          {/* Heading with Buttons Row */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <h1 className="text-[42px] font-extrabold font-inter text-secondary">
              {appDetails.name}
            </h1>

            <div className="flex gap-2">
              {project_type === "Normal" && (
                <button
                  className="bg-primary text-white text-sm font-medium px-4 py-2 rounded-lg
                  hover:scale-105 transition-transform duration-300"
                  style={{ willChange: "transform" }}
                  onClick={() =>
                    navigate("/productpricing", { state: { id, project_type } })
                  }
                >
                  Go To Pricing
                </button>
              )}

              <button
                className="bg-primary text-white text-sm font-medium px-4 py-2 rounded-lg
                hover:scale-105 transition-transform duration-300"
                style={{ willChange: "transform" }}
                onClick={() => {
                  navigate("/editApplication", { state: { id: id } });
                }}
              >
                Edit Application Details
              </button>
            </div>
          </div>

          {/* Description */}
          <h1 className="text-[28px] blacktext mt-4">{appDetails.tagline}</h1>
          <p className="text-[14px] text-black mt-2">{appDetails.description}</p>

          {/* Image Placeholder */}
          <div className=" mt-4">
            <img
              src={appDetails.image}
              alt={appDetails.name}
              className="w-full object-cover rounded-2xl h-[250px]"
            />
          </div>

          {/* Heading with Button */}
          <div className="flex flex-col  sm:flex-row items-end sm:items-start justify-between gap-4 mt-10 w-full">
            <h1 className="text-3xl font-extrabold font-inter text-secondary w-full ">
              {appDetails.feature_title}
            </h1>

            {/* <button
              className="bg-primary text-white text-sm font-medium px-4 py-2 rounded-lg
              hover:scale-105 transition-transform duration-300"
              style={{ willChange: "transform" }}
              onClick={() => {
                navigate("/editApplication", { state: { id: id } });
              }}
            >
              Edit App Feature
            </button> */}
          </div>

          {/* Feature Grid */}
          <div className=" max-w-7xl  my-9">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 xl:gap-8">
              {appDetails.features.map((feature) => (
                <div
                  key={feature.id}
                  className="bg-white rounded-2xl flex flex-col p-5  h-80"
                  style={{ boxShadow: "0px 0px 4px 0px #00000040" }}
                >
                  {/* Icon */}
                  <div className="mb-3">
                    <div className="w-12 h-12 rounded-full overflow-hidden">
                      <img
                        src={feature.logo}
                        alt={feature.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>

                  {/* Title */}
                  <h2 className="text-xl font-semibold text-[#4C3A68] mb-2">
                    {feature.name}
                  </h2>

                  {/* Description */}
                  <p className="text-sm text-[#4C3A68]">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
